import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import StickyHeadTable from "./StickyHeadTable";
import { isMobile } from "react-device-detect";
import { getSaleStatus } from "./utils/applibs";
import dateFormat from "dateformat";
import PageWrapper from "./layout/PageWrapper";
import RecordsBox from "./RecordsBox";

const AdminSales = function (props) {
  const theme = useTheme();
  const {
    sales: items,
    businessType,
    superUser,
    onDelete,
    onEdit,
    onRefreshData,
    onPdfRequest,
    canEdit,
    search,
  } = props;

  const [itemsForSelection, setItemsForSelection] = React.useState([]);

  const handleItemsForSelectionChange = (items) => {
    setItemsForSelection(items);
  };

  const displayedColumnsInitial = [
    { id: "saleId", label: "#", minWidth: 50, align: "left" },
    { id: "saleAmount", label: "Montant", minWidth: 50 },
    { id: "nb", label: "Unité", minWidth: 50 },
    {
      id: "titleFormatted",
      label: "Produit",
      maxWidth: isMobile ? 90 : 250,
      minWidth: isMobile ? 90 : 170,
    },
    { id: "platform", label: "Plateforme", minWidth: 120 },
    { id: "saleUppTransactionNumber", label: "Remote ref.", minWidth: 170 },
    { id: "saleRefNumber", label: "Réf. vente", minWidth: 170 },
    { id: "hasFormulaire", label: "Formulaire", minWidth: 60 },
    { id: "saleStatus", label: "Status", minWidth: 50 },
    { id: "saleCreated", label: "Créé le", minWidth: 60 },
    { id: "action", label: "Actions", minWidth: isMobile ? 20 : 120 },
  ];

  const displayedColumns = superUser
    ? displayedColumnsInitial
    : displayedColumnsInitial.filter(
        (c) => c.id !== "saleUppTransactionNumber"
      );

  return (
    <PageWrapper>
      <RecordsBox items={items} itemsForSelection={itemsForSelection} />

      <StickyHeadTable
        search={search}
        businessType={businessType}
        superUser={superUser || true}
        filters={[
          "saleId",
          "saleCreated",
          "productName",
          "saleAmount",
          "saleCurrency",
          "saleReferer",
          "saleRefNumber",
          "saleStatus",
          "saleUppTransactionNumber",
          "platform",
          "userFirstname",
          "userLastname",
          "userMobile",
        ]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) =>
                  c.id === "titleFormatted" ||
                  c.id === "saleStatus" ||
                  c.id === "action"
              )
            : displayedColumns
        }
        data={items.map((i) => ({
          ...i,
          ...{
            id: i.saleId,
          },
          ...{
            titleFormatted:
              false && !isMobile
                ? `${i.productName} <br/> ${(
                    i.saleReferer || "undefined!"
                  ).replace(/http(s)?:\/\//gi, "")}`
                : isMobile && i.Formalyze && i.Formalyze.formId
                  ? `📋 ${i.productName}`
                  : `${i.productName}`,
          },
          ...{ saleAmount: `${i.saleAmount} ${i.saleCurrency}` },
          ...{ productName: `${i.productName} #${i.productId}` },
          ...{
            platform: (() => {
              const referer = i.saleReferer || "";
              if (referer.includes("kadomi.ch")) {
                return "Kadomi.ch";
              } else if (referer.includes("kadomi.shop")) {
                return "Kadomi.shop";
              } else if (referer.includes("internal")) {
                return "Interne";
              } else {
                const domain = referer
                  .replace(/http(s)?:\/\//gi, "")
                  .split("/")[0]
                  .split("?")[0];
                return domain || "N/A";
              }
            })(),
          },
          ...{
            hasFormulaire: i.Formalyze && i.Formalyze.formId ? "Oui" : "Non",
          },
          ...{
            saleCreated: dateFormat(i.saleCreated, "mmm dS, H:MM"),
          },
          ...{
            saleStatus: getSaleStatus(i.saleStatus),
          },
        }))}
        onDelete={onDelete}
        onEdit={onEdit}
        onItemsForSelectionChange={handleItemsForSelectionChange}
        onRefreshData={onRefreshData}
        checkboxEnabled={true}
        onPdfRequest={canEdit ? onPdfRequest : null}
      />
    </PageWrapper>
  );
};

export default AdminSales;
